<h2 mat-dialog-title>Edit user</h2>
<mat-dialog-content>
  <p class="sub">Username: <strong>{{ data.user.username }}</strong></p>
  <small class="text-danger" *ngIf="msg">{{ msg }}</small>
  <form [formGroup]="form" class="dialog-form">
    <div class="row2">
      <mat-form-field appearance="outline">
        <mat-label>First name</mat-label>
        <input matInput formControlName="firstName" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Last name</mat-label>
        <input matInput formControlName="lastName" />
      </mat-form-field>
    </div>
    <mat-form-field appearance="outline" class="full">
      <mat-label>Email</mat-label>
      <input matInput type="email" formControlName="email" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="full">
      <mat-label>Phone</mat-label>
      <input matInput formControlName="phoneNumber" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="full">
      <mat-label>New password (optional)</mat-label>
      <input matInput type="password" formControlName="newPassword" autocomplete="new-password" />
      <mat-hint>Leave blank to keep current password. Min 6 characters if set.</mat-hint>
      <mat-error *ngIf="form.get('newPassword')?.errors?.minlength">At least 6 characters</mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="submit()" [disabled]="form.invalid || saving">
    {{ saving ? 'Saving…' : 'Save' }}
  </button>
</mat-dialog-actions>
